import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { HERA_BASE_URL, OneKycParams, SDK_BASE_URL } from "../../constants";
import { Box, Button, ErrorContent, Loading } from "../../components";
import {
  useOneKycResult,
  useResultTranslation,
} from "../forms/OwnerInfo/liveness/hooks";
import { ResultData } from "../forms/OwnerInfo/liveness/Result.modal";
import { SDK_FLOW } from "../../helpers";

export const OneKycCallbackScreen = () => {
  const location = useLocation();
  const [result, setResult] = useState<ResultData | null>(null);
  const { loading, handleResult } = useOneKycResult({
    onHandleResult: (data: ResultData) => setResult(data),
  });
  const { image, title, description, buttonText } = useResultTranslation(
    result,
    null
  );

  const handleButtonClick = () => {
    const flow = new URLSearchParams(location.search).get("flow");
    window.location.href = flow === SDK_FLOW ? SDK_BASE_URL : HERA_BASE_URL;
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get(OneKycParams.Status);
    const partnerSessionId = params.get(OneKycParams.PartnerSessionId);
    const errorCode = params.get(OneKycParams.ErrorCode);

    handleResult({
      status,
      partner_session_id: partnerSessionId,
      error_code: errorCode,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <Loading />;
  if (!result) return null;

  return (
    <Box flex flexDirectionColumn alignCenter justifyCenter paddingL>
      <ErrorContent image={image} title={title} description={description} />
      <Button width100 marginTopL onClick={handleButtonClick}>
        {buttonText}
      </Button>
    </Box>
  );
};
